module.exports = __webpack_public_path__ + "static/media/sn-1500lcd.6e25eddd.jpg";